<div class="modal-header">
  <h2 class="hotel_name" id="modal-header">
    <span i18n="@@ratesHotelLiveRates">Live Rates for</span> {{ hotel.name }}
  </h2>
  <button
    class="light-icon-button close"
    (click)="close()"
    attr.aria-label="Close Live Rates for {{ hotel.name }} Modal"
    ngbAutoFocus
  >
    <i class="ico-cancel AA-standard-grey" aria-hidden="true"></i>
  </button>
</div>
<!-- <app-filter-hotel-user-favorite [hotelName]="hotelName"
                                (changeFilter)="changeFilter()"></app-filter-hotel-user-favorite> -->
<div class="modal-body">
  @if (swapSellMessage) {
    <div class="alert alert-warning alert-dismissible" role="alert">
      @if (showSwapSellHotelGroupLink) {
        <strong class="swap-sell-link" (click)="changeHotelChainFilter()">Click Here!</strong>
      }
      {{ swapSellMessage }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  }
  @if (showCtmAccreditation) {
    <div class="room-rate-row accreditrationArrea">
      <div class="accreditrationText">
        <h3 class="smallHeader" i18n="@@hoterates_accreditation_header1">CTM PARTNERS</h3>
        <h2 class="bold" i18n="@@hoterates_accreditation_header2">Business Ready</h2>
        <p i18n="@@hoterates_accreditation_text">
          This hotel has introduced several measures to ensure the safety and wellbeing of both
          their guests and employees.
        </p>
        <h3 class="bold" i18n="@@hoterates_accreditation_header3t">These measures cover:</h3>
        <ul>
          <li i18n="@@hoterates_accreditation_text_cover1">
            Enhanced cleaning protocols throughout the hotel
          </li>
          <li i18n="@@hoterates_accreditation_text_cover2">Enforced social distancing practices</li>
          <li i18n="@@hoterates_accreditation_text_cover3">PPE where relevant</li>
          <li i18n="@@hoterates_accreditation_text_cover4">Amended food and beverage offering</li>
        </ul>
      </div>
      <div class="accreditrationImage">
        <img src="https://images.sabscorp.com/images/icons/covid19-mask-lg.png" alt="" />
      </div>
    </div>
  }

  @if (loading) {
    <div>
      <app-loading-spinner size="sm" />
    </div>
  }

  @if (!loading) {
    <div>
      @for (room of rooms.rooms; track room; let last = $last; let j = $index) {
        <div class="room-rate-row">
          <div class="rate_container">
            <div class="room_code_display">
              <div class="room-code-display__title-toast">
                <p>
                  {{ room.roomType | translate | slice: 0 : getShortRoomType(room) }}
                  @if (room.rateSource) {
                    <span>({{ room.rateSource }})</span>
                  }
                  :
                </p>
                @if (contains(room.rateDescription, 'ccs')) {
                  <section (mouseleave)="tt.close()" class="container">
                    <i
                      _ngcontent-c12=""
                      class="ico-heart heart-img"
                      src="https://images.sabscorp.com/images/sabs2/icons/star.png"
                      ngbTooltip="Preferred"
                      attr.aria-label="Preferred"
                      i18n-ngbTooltip
                      triggers="manual"
                      #tt="ngbTooltip"
                      (mouseenter)="tt.open()"
                      placement="bottom"
                      (focus)="tt.open()"
                      (blur)="tt.close()"
                      tabindex="0"
                      ><span class="visuallyhidden" i18n="@@Preferred">Preferred</span></i
                    >
                  </section>
                }
                <div class="rate-description-wrapper">
                  <app-breakfast-icon [room]="room"></app-breakfast-icon>
                  <div class="room-code-display__body">
                    @if (room.rateDescription !== room.roomType) {
                      <span>
                        <span>{{
                          room.rateDescription.length > rateDescriptionMaxLength
                            ? (room.rateDescription | slice: 0 : rateDescriptionMaxLength) + '...'
                            : room.rateDescription
                        }}</span>
                      </span>
                    }
                    @for (item of room.additional?.details; track item) {
                      <span>
                        {{ item?.Description }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="room-rate-action-btns">
              <button
                (click)="room.showDetail = !room.showDetail"
                class="rate_select_button"
                id="hotel-rate-select{{ j }}"
                type="button"
                attr.aria-label="Info and add to basket for {{
                  getPrice(room) | currency: room.currencyCode : 'symbol'
                }} {{ room.roomType }} {{
                  room.rateDescription.length > rateDescriptionMaxLength
                    ? (room.rateDescription | slice: 0 : rateDescriptionMaxLength) + '...'
                    : room.rateDescription
                }}"
                attr.aria-expanded="{{ room.showDetail ? 'true' : 'false' }}"
              >
                <span i18n="@@dialogTabButtonInfoAnd">Info and </span>
                @if (!gmt && !displayItinerary) {
                  <span i18n="@@dialogTabButtonAddToBasket">add to basket</span>
                }
                @if (!gmt && displayItinerary) {
                  <span i18n="@@dialogTabButtonAddToItinerary">add to itinerary</span>
                }
                @if (gmt) {
                  <span i18n="@@dialogTabButtonGmtselect">select</span>
                }
              </button>
            </div>
            @if (room.nights.length >= 2) {
              <div class="room_price">
                <span id="hotel-SGD-price{{ j }}"
                  >{{ getPrice(room) | currency: room.currencyCode : 'symbol' }}
                  @if (showPricePerRoomPerNight()) {
                    <span
                      >/
                      {{ getPricePerRoomPerNight(room) | currency: room.currencyCode : 'symbol' }}
                      <span i18n="@@itemHotelsPRPN">prpn</span>
                    </span>
                  }
                </span>
                <br />
                @if (
                  room.currencyConversion?.convertedCode !== room.currencyConversion?.localCode
                ) {
                  <span>
                    &nbsp;(
                    <span i18n="@@ratesHotelApproxRate">Approx</span>:
                    {{
                      room.currencyConversion.convertedTotal
                        | currency: room.currencyConversion.convertedCode
                    }}
                    @if (showPricePerRoomPerNight()) {
                      /
                      {{
                        getConvertedPricePerRoomPerNight(room)
                          | currency: room.currencyConversion.convertedCode
                      }}
                    }
                    )
                  </span>
                }
                <a
                  class="room_price_breakdown"
                  (click)="togglePriceBreakdown(j)"
                  (keydown.enter)="togglePriceBreakdown(j)"
                  tabindex="0"
                >
                  @if (!displayPriceBreakdown[j]) {
                    <span i18n="@@showPriceBreakdown">Show Price Breakdown</span>
                  }
                  @if (displayPriceBreakdown[j]) {
                    <span i18n="@@hidePriceBreakdown">Hide Price Breakdown</span>
                  }
                  <span class="sr-only">
                    - {{ getPrice(room) | currency: room.currencyCode : 'symbol' }}
                    {{ room.roomType }}
                    {{ room.rateDescription.length > rateDescriptionMaxLength }}
                  </span>
                </a>
              </div>
            } @else {
              <span id="hotel-SGD-price{{ j }}"
                >{{ getPrice(room) | currency: room.currencyCode : 'symbol' }}
                @if (showPricePerRoomPerNight()) {
                  <span
                    >/
                    {{ getPricePerRoomPerNight(room) | currency: room.currencyCode : 'symbol' }}
                    <span i18n="@@itemHotelsPRPN">prpn</span>
                  </span>
                }
              </span>
              <br />
              @if (room.currencyConversion?.convertedCode !== room.currencyConversion?.localCode) {
                <span>
                  (
                  <span i18n="@@ratesHotelApproxRate">Approx</span>:
                  {{
                    room.currencyConversion.convertedTotal
                      | currency: room.currencyConversion.convertedCode
                  }}
                  )
                </span>
              }
            }
            <div class="message_div">
              <app-warning-tags
                [iconId]="j"
                [ticket]="room"
                [displayCheck]="true"
              ></app-warning-tags>
            </div>
          </div>
          @if (displayPriceBreakdown[j]) {
            <app-price-breakdown-dialog [room]="room" [hotel]="hotel"></app-price-breakdown-dialog>
          }
          @if (room.showDetail) {
            <div class="room_details">
              <span
                class="conidtions_header"
                (click)="room.showDetail = false"
                role="button"
                i18n="@@ratesHotelBookingConditions"
                >Booking conditions:</span
              >
              @if (warnAboutSource(room.rateSource)) {
                <div class="rate_source_warning">
                  This is a {{ room.rateSource }} rate, please read the rate rules carefully
                </div>
              }
              <div>
                <h4 class="condition_title" i18n="@@rateInformation">Rate Information:</h4>
                <span>
                  {{ room.roomType }}
                  @if (room.rateSource) {
                    <span>({{ room.rateSource }})</span>
                  }
                  :
                </span>
                <span>{{ room.rateDescription }}</span>
                @for (item of room.additional?.details; track item) {
                  <span>
                    {{ item?.Description }}
                  </span>
                }
              </div>
              @for (cond of listOfHotelPolicies; track cond) {
                <div>
                  @if (room.policies[cond] && cond === HotelPolicyEnum.cancellation) {
                    <div>
                      <h4 class="condition_title room_error">
                        <span i18n="@@cancellationPolicy">Cancellation Policy:</span>
                        <i
                          tabindex="0"
                          class="ico-exclaim-1 ico-exclaim-1--strong cancellation-tooltip-icon ng-star-inserted"
                          aria-label="Cancellation policy: {{ room.policies[cond] }}"
                        >
                          <div class="cancellation-tooltip">
                            <div class="cancellation-tooltip-arrow"></div>
                            <span i18n="@@cancellationPolicy">Cancellation Policy:</span>
                            @if (hotel.source === ServiceProvider.TravelportHotels) {
                              <span i18n="@@cancellationDealine">Cancellation Deadline:</span>
                              {{ room.policies[cond] | date: 'dd/MM/yyyy HH:mm' }}
                            } @else {
                              {{ room.policies[cond] }}
                            }
                          </div>
                        </i>
                      </h4>
                      <span class="room_error">
                        @if (hotel.source === ServiceProvider.TravelportHotels) {
                          <span i18n="@@cancellationDealine">Cancellation Deadline:</span>
                          {{ room.policies[cond] | date: 'dd/MM/yyyy HH:mm' }}
                        } @else {
                          {{ room.policies[cond] }}
                        }
                      </span>
                    </div>
                  }
                </div>
              }
              @if (room.roomDescription) {
                <div>
                  <h4 class="condition_title" i18n="@@roomInformation">Room Information:</h4>
                  <span>{{ room.roomDescription }}</span>
                </div>
              }
              @for (cond of listOfHotelPolicies; track cond) {
                <div>
                  @if (room.policies[cond] && cond === HotelPolicyEnum.general) {
                    <div>
                      <h4 class="condition_title" i18n="@@generalPolicies">General Policies:</h4>
                      <span>{{ room.policies[cond] }}</span>
                    </div>
                  }
                </div>
              }
              @for (cond of listOfHotelPolicies; track cond) {
                <div>
                  @if (room.policies[cond] && cond === HotelPolicyEnum.disabledAccess) {
                    <div>
                      <h4 class="condition_title" i18n="@@disabledAccessPolicy">
                        Disabled Access Policy:
                      </h4>
                      <span>{{ room.policies[cond] }}</span>
                    </div>
                  }
                </div>
              }
              <!-- Rate Code start -->
              @if (room.rateCode && hotel.source === ServiceProvider.Confirma) {
                <div>
                  <h4 class="condition_title" i18n="@@rateCode">Rate Code:</h4>
                  <span>{{ room.rateCode }}</span>
                </div>
              }
              @if (room.additional?.productCode && hotel.source === ServiceProvider.SabreCSL) {
                <div>
                  <h4 class="condition_title" i18n="@@rateCode">Rate Code:</h4>
                  <span>{{ room.additional?.productCode }}</span>
                </div>
              }
              <!-- Rate Code end -->
              @if (hotel.source) {
                <div>
                  <h4 class="condition_title" i18n="@@rateProvider">Rate Provider:</h4>
                  <span>{{ hotel.source }}</span>
                </div>
              }
              @for (cond of listOfHotelPolicies; track cond) {
                <div>
                  @if (room.policies[cond] && cond === HotelPolicyEnum.guarantee) {
                    <div>
                      <h4 class="condition_title" i18n="@@guaranteePolicy">Guarantee Policy:</h4>
                      <span>{{ room.policies[cond] }}</span>
                    </div>
                  }
                  @if (room.policies[cond] && cond === HotelPolicyEnum.deposit) {
                    <div>
                      <h4 class="condition_title" i18n="@@depositPolicy">Deposit Policy:</h4>
                      <span>{{ room.policies[cond] }}</span>
                    </div>
                  }
                </div>
              }
              <div class="flex-row-container select-rate-btn">
                @if (gmt) {
                  <div>
                    <button
                      (click)="selectNewRoomIdGMT(j, gmtSelectedRoomIndex !== j)"
                      [disabled]="room.unavailable && !canOverride"
                      appButton="small"
                      id="hotel-selected-{{ j }}"
                      attr.aria-label="Select {{
                        roomPrices[room.roomId] | currency: room.currencyCode : 'symbol'
                      }} {{ room.roomType }} to bolt"
                      attr.aria-expanded="{{ room.showDetail }}"
                      tabindex="0"
                    >
                      {{ (gmtSelectedRoomIndex === j ? 'Deselect' : 'Select') | translate }}
                    </button>
                  </div>
                } @else {
                  <button
                    (click)="addToCart(room)"
                    [disabled]="room.unavailable && !canOverride"
                    appButton="small"
                    id="hotel-add-to-basket-{{ j }}"
                    attr.aria-label="Add {{
                      getPrice(room) | currency: room.currencyCode : 'symbol'
                    }} {{ room.roomType }} to basket"
                    attr.aria-expanded="{{ room.showDetail }}"
                    tabindex="0"
                  >
                    @if (!displayItinerary) {
                      <span i18n="@@addToBasket">Add to Basket</span>
                    }
                    @if (displayItinerary) {
                      <span i18n="@@addToItinerary">Add to Itinerary</span>
                    }
                  </button>
                }
              </div>
              @if (room.errorConditions && !room.loadingConditions) {
                <div>
                  <span class="room_error" i18n="@@ratesHotelErrorLoading"
                    >Error loading room conditions.</span
                  >
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
